import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'htmlToPlainText' })
export class HTMLToPlainTextPipe implements PipeTransform {
  public transform(stringToConvert: string): any {
    return stringToConvert ? String(stringToConvert).replace(/<.+?>/gm, '') : '';
  }
}
